import { conc2aqi } from '../common/scale';
import { aqiSmoothColor } from '../common/colors';
import C from '../common/C';
import './dashboard.scss';
import { PubSub } from '../common/pubsub';
import { StationHourlyGraph } from '../visu/hourly';
import "@fontsource/noto-sans";
import { logout } from '../login/login';
var Dashboard = /** @class */ (function () {
    function Dashboard(body, v_spinner) {
        var _this = this;
        this.v_spinner = v_spinner;
        this.v_source_map = {};
        this.v_species = {};
        this.events = new PubSub();
        this.currentHighlightedStation = null;
        this.currentGraphView = null;
        this.v_body = body;
        body.html('');
        body.c('div', 'title').html("AIRBACUS<span style='font-size:50%'>.ORG</span>");
        body.c('div', 'subtitle').html("air quality data store<br>build version " + require('../../package.json').version);
        this.v_bounds = body.c('div', 'geoinfo').hide();
        body.c('button', 'api button').html("API documentation").on("click", function () {
            var modal = C.select(document.body).c('div', 'modal');
            modal.c("div", "background");
            var content = modal.c("div", "content");
            content.c("button", { float: "right" }).html("Close").on("click", function () {
                modal.remove();
            });
            content.c("div").html("The programatic API is available on github: <a href='https://github.com/aqicn/abacus' target='_abacus'>github.com/aqicn/abacus</a>");
            var url = (window.location.toString().split("#")[0]);
            content.c("p").html("Use the server configuration <b>" + url + "</b> as the base url.");
        });
        body.c('button', 'api button').html("About").on("click", function () {
            var modal = C.select(document.body).c('div', 'modal');
            modal.c("div", "background");
            var content = modal.c("div", "content");
            content.c("button", { float: "right" }).html("Close").on("click", function () {
                modal.remove();
            });
            content.c("div").html("\n                AirBacus - the open air quality data store.<br>\n                For more information, check <a href=\"https://aqicn.org/data-platform/\" target=\"_aqicn\">aqicn.org/data-platform</a>\n                ");
        });
        this.v_auth = body.c('button', 'api button').hide();
        var columns = body.c('div', 'columns');
        var column1 = columns.c('div', 'column1');
        var column2 = columns.c('div', 'column2');
        column1.c('div', 'header').html('Species');
        var v_species = column1.c('div', 'species');
        this.v_debug = column1.c('div');
        column2.c('div', 'header').html('Feeds');
        this.v_sources = column2.c('div', 'sources');
        this.v_selection = body.c('div', 'selection');
        var species = ['pm25', 'pm10', 'o3', 'o3_8', 'no2', 'so2', 'co'];
        species.forEach(function (specie) {
            _this.v_species[specie] = v_species
                .c('button', 'ui button')
                .html(specie)
                .on('click', function () {
                _this.selectSpecie(specie);
            });
        });
    }
    Dashboard.prototype.setUser = function (auth) {
        this.v_auth.show().html("<div>Logout</div>"
        // `<small>${auth.user.claims?.sub}</small>`
        // '<br>Your IP: ' +
        // auth.user.ip
        ).on("click", function () {
            logout().then(function (x) { return window.location.reload(); });
        });
    };
    Object.defineProperty(Dashboard.prototype, "activeSpecie", {
        get: function () {
            return this.m_selectedSpecie;
        },
        enumerable: false,
        configurable: true
    });
    Dashboard.prototype.selectSpecie = function (specie) {
        var _this = this;
        Object.values(this.v_species).forEach(function (b) {
            return b.node().classList.remove('active');
        });
        this.v_species[specie].node().classList.add('active');
        this.m_selectedSpecie = specie;
        this.v_spinner.show();
        return this.m_view.reload().then(function () {
            _this.v_spinner.hide();
            _this.m_router.setSpecie(specie);
            _this.events.publish('specie', specie);
        })
            .catch(function (e) {
            _this.v_spinner.hide();
        });
    };
    Dashboard.prototype.debug = function (s) {
        this.v_debug.html(s);
    };
    Dashboard.prototype.bounds = function (b) {
        // this.v_bounds.html(
        //     'NW: ' +
        //         b.getNorth().toFixed(3) +
        //         ',' +
        //         b.getWest().toFixed(3) +
        //         '<br>' +
        //         'SE: ' +
        //         b.getSouth().toFixed(3) +
        //         ',' +
        //         b.getEast().toFixed(3)
        // )
    };
    Dashboard.prototype.source = function (name, count, outdated) {
        var _this = this;
        if (!this.v_source_map[name]) {
            var view = (this.v_source_map[name] = this.v_sources.c('div', 'source'));
            view.on('mouseover', function () {
                _this.m_view.showOnlySource(name);
            }).on('mouseout', function () {
                _this.m_view.showAllSources();
            });
            // Need to resort
            var sources = Object.keys(this.v_source_map);
            sources.sort(function (a, b) { return (a > b ? -1 : 1); });
            var parent_1 = this.v_sources.node();
            sources.forEach(function (name) {
                var node = _this.v_source_map[name].node();
                parent_1.appendChild(node);
            });
            // view.tooltip(name)
        }
        var _a = name.split('.'), countryCode = _a[0], feed = _a[1];
        if (name == "airnet") {
            feed = "airnet";
            countryCode = "";
        }
        this.v_source_map[name].html(iso2flag(countryCode) + feed.toLocaleUpperCase());
        // this.v_source_map[name].html(
        //     `${name}: <label class='count'>${count}</label> <label class='outdated'>${outdated}</label>`
        // )
    };
    Dashboard.prototype.highlight = function (selection) {
        var _this = this;
        var station = selection[0];
        if (this.currentHighlightedStation == station) {
            return;
        }
        if (this.currentGraphView)
            this.currentGraphView.cancel();
        this.currentHighlightedStation = station;
        var div = this.v_selection.html('').c('div', 'station-readings');
        div.c('div', 'header').html('Station Info');
        var header = div.c('div', 'properties');
        var iso = station.source.split('.')[0];
        header
            .c('div')
            .html("<label>feed</label> ".concat(station.source, "  ").concat(iso2flag(iso)));
        div.c('div', 'header').html('Real-time Readings');
        var table = div.c('table');
        var graph = div.c('div', {
            textAlign: 'center',
        });
        this.currentHighlightedStation = station;
        station.readings().then(function (readings) {
            if (_this.currentHighlightedStation != station)
                return;
            if (!readings) {
                header
                    .c('div')
                    .html("Login to see readings");
                return;
            }
            header
                .c('div')
                .html("<label>station</label> ".concat(readings.metadata.StationID));
            var md = readings.metadata.Data;
            if (typeof md.name === "string") {
                header
                    .c('div')
                    .html("<label>name<sub>en</sub></label>".concat(md.name, " "));
            }
            else if (md.name) {
                for (var lang in md.name) {
                    for (var key in md.name[lang]) {
                        var val = md.name[lang][key];
                        header
                            .c('div')
                            .html("<label>".concat(key, "<sub>").concat(lang, "</sub></label> ").concat(val, " "))
                            .tooltip(val);
                    }
                }
            }
            var species = Object.keys(readings.readings);
            species.sort();
            species.forEach(function (specie) {
                if (specie.indexOf('_lvl') > 0)
                    return;
                var reading = readings.readings[specie];
                var e = table.c('tr', 'readings');
                var sdt = '';
                var ut = new Date(reading.time);
                var dt = (Date.now() - ut.getTime()) / 1000;
                if (dt < 3600) {
                    sdt = Math.round(dt / 60) + ' min';
                }
                else if (dt < 3600 * 24) {
                    sdt = Math.round(dt / 3600) + ' hour';
                }
                else if (dt < 3600 * 24 * 3) {
                    sdt = Math.round((dt * 10) / (24 * 3600)) / 10 + ' day';
                }
                else {
                    sdt = Math.round(dt / (24 * 3600)) + ' days';
                }
                var aqi = Math.round(conc2aqi(reading.value, specie, reading.unit));
                var bgcolor = aqiSmoothColor(aqi, 'b', specie);
                var fgcolor = aqiSmoothColor(aqi, 'f', specie);
                var block = "<div style='background-color:".concat(bgcolor, ";color:").concat(fgcolor, ";width:32px;height:16px;'>").concat(aqi, "</div>");
                e.html('<td>' +
                    specie +
                    '<td>' +
                    sdt +
                    '<td>' +
                    reading.value +
                    '<small> ' +
                    reading.unit +
                    '<td>' +
                    block);
                if (specie == _this.m_selectedSpecie)
                    _this.currentGraphView = StationHourlyGraph.create(graph).show(station, specie, reading.unit);
            });
        }).catch(function (e) {
            console.log(e);
        });
    };
    Dashboard.prototype.setView = function (view) {
        this.m_view = view;
        return this;
    };
    Dashboard.prototype.setRouter = function (router) {
        this.m_router = router;
        return this;
    };
    return Dashboard;
}());
export { Dashboard };
function iso2flag(iso) {
    var codePoints = iso
        .toUpperCase()
        .split('')
        .map(function (char) { return 127397 + char.charCodeAt(); });
    var flag = String.fromCodePoint.apply(String, codePoints);
    return flag;
}
